import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "columns"
};
const _hoisted_2 = { class: "column is-one-fifth" };
const _hoisted_3 = { class: "column" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
    key: 1,
    class: "progress is-primary"
};
import { loading_success } from "@/lib/helpers";
import { PublicStore } from "@/lib/store/public";
import { marked } from "marked";
import { defineAsyncComponent } from "vue";
import EventMenu from "../EventMenu.vue";
import GuestView from "./GuestView.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MainView',
    setup(__props) {
        const store = PublicStore();
        const AdminView = defineAsyncComponent(() => import("./AdminView.vue"));
        const ManagerView = defineAsyncComponent(() => import("./ManagerView.vue"));
        return (_ctx, _cache) => {
            return (_unref(loading_success)(_unref(store).events))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(EventMenu)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        (_unref(store).website_config.info !== '')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "content",
                                innerHTML: _unref(marked).parse(_unref(store).website_config.info)
                            }, null, 8, _hoisted_4))
                            : _createCommentVNode("", true),
                        (_unref(store).events.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_unref(store).user === null)
                                    ? (_openBlock(), _createBlock(GuestView, { key: 0 }))
                                    : (_unref(store).user.role === 'ADMIN')
                                        ? (_openBlock(), _createBlock(_unref(AdminView), { key: 1 }))
                                        : (_unref(store).user.role === 'MANAGER')
                                            ? (_openBlock(), _createBlock(_unref(ManagerView), { key: 2 }))
                                            : _createCommentVNode("", true)
                            ], 64))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: "notification is-primary",
                                innerHTML: _unref(marked).parse(_unref(store).website_config.msg_no_events)
                            }, null, 8, _hoisted_5))
                    ])
                ]))
                : (_openBlock(), _createElementBlock("progress", _hoisted_6));
        };
    }
});
